import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-bag',
  templateUrl: './icon-bag.component.html',
  styleUrls: ['./icon-bag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconBagComponent {}
